export const JSPM_PACKAGE_JSON_DEFAULT = {
  directories: {
    baseURL: '.',
    packages: 'jspm_packages'
  },
  // The default value shows where the config files can be.
  // Except `jspm.config.js`, other files may not exist.
  configFiles: {
    jspm: 'jspm.config.js',
    'jspm:browser': 'jspm.browser.js',
    'jspm:dev': 'jspm.dev.js',
    'jspm:node': 'jspm.node.js'
  }
}
